import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useProjectState, setProjectState } from '@starflow/app/store';
import { Input } from 'antd';
import { FlOW_PROJECT_INFO, FlOW_SOCKET_INFO, FlOW_TYPE, NodeState } from '../../constants';
import { eventBus } from '@starflow/app/helpers';
import { Tooltip } from '@mantine/core';
import { isGtLen } from '../../utils';

const LabelEditer = React.memo(({ data, className, type }) => {
  const { id } = data;
  const nodeMap = useProjectState('nodeMap');
  const [text, setText] = useState('');
  useEffect(() => {
    setText(data.label);
  }, [data]);
  const ref = useRef(null);
  const targetState = nodeMap[id]?.data?.state ?? [];
  const syncData = () => {
    setProjectState({
      nodeMap: {
        ...nodeMap,
        [id]: {
          ...nodeMap[id],
          data: {
            ...nodeMap[id].data,
            label: text,
            state: targetState.filter((s) => s !== NodeState.TextEditing),
          },
        },
      },
    });
    // 将改动同步到后端
    data.flowId
      ? eventBus.emit(FlOW_SOCKET_INFO, {
          flowId: data.flowId,
          tp: FlOW_TYPE.UPDATE,
        })
      : eventBus.emit(FlOW_PROJECT_INFO, { tp: FlOW_TYPE.UPDATE });
  };

  const isTextEditing = useMemo(() => {
    const state = data?.state ?? [];
    const flag = state.some((s) => s === NodeState.TextEditing);
    if (flag) {
      setTimeout(() => {
        ref.current?.focus();
        ref.current?.select();
      }, 200);
    }
    return flag;
  }, [data?.state?.length, id, type]);

  return (
    <div className={className}>
      {isTextEditing ? (
        <Input
          onClick={(e) => (e.stopPropagation(), e.preventDefault())}
          onMouseDown={(e) => e.stopPropagation()}
          onMouseMove={(e) => e.preventDefault()}
          style={{ borderWidth: 0, boxShadow: '0 0 0 0' }}
          ref={ref}
          value={text}
          onChange={(e) => setText(e.target.value)}
          onBlur={() => syncData()}
          onKeyUp={(e) => e.keyCode === 13 && syncData()}
        />
      ) : (
        <>
          {isGtLen(text) ? (
            <Tooltip withArrow position="top" offset={10} className="scale-90" label={text}>
              <div
                data-type={type}
                data-id={id}
                className="overflow-ellipsis overflow-hidden whitespace-nowrap w-[100px] text-left"
              >
                {text}
              </div>
            </Tooltip>
          ) : (
            text
          )}
        </>
      )}
    </div>
  );
});

export default LabelEditer;
